<template lang="pug">
.greenhouse-job-board-with-search.container
  section.search
    .row.f-secondary.xs-f-xxxlarge.sm-f-grande.md-f-xgrande.lg-f-xgrande.max-at-tweak
      p.searchJobs {{overTitle}}
      h2.main-title {{title}}

    .row
      .filterJobs

        MrDropdown.xs-12.md-5.search-input(label="Locations" :options="locationOptions" v-model='selectedLocation' :disabled="processing")
        MrDropdown.xs-12.md-5.search-input(label="Role Type" :options="roleOptions" v-model='selectedRole' :disabled="processing")

        button.mr-btn.search-button(@click="getJobs" :disabled="processing") Search

    .row.jobsContainer
      .jobRow(:class="{'.with-content': paginatedJobs.length}")
        .job(v-for="job in paginatedJobs" :key="job.id")
          a.position(:href="jobUrl(job)" target="_blank") {{job.title}}

          .city-posType
            p.city {{job.location.name}}
              span(v-if="job.metadata") &bull;

            p.job-type(v-if="jobType(job)") {{ jobType(job) }}

          .viewMoreSocial
            a.viewMore.upper(:href="jobUrl(job)" target="_blank") Role details
            .social
              a.fb-share(:href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(jobUrl(job))}`" target="_blank")
                svg(xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 20" role="img")
                  title#facebook Facebook
                  desc#facebookDesc Link to this job posting on Facebook
                  path(d="M8.17 3.32H10V.14A24.47 24.47 0 007.34 0C4.71 0 2.9 1.66 2.9 4.7v2.8H0v3.55h2.9v9h3.57v-8.99h2.78L9.7 7.5H6.47V5.05c0-1 .27-1.73 1.7-1.73z" fill="#735e73")

              a.tw-share(:href="`https://twitter.com/intent/tweet?url=${encodeURIComponent(jobUrl(job))}`" target="_blank" role="img")
                svg(xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16")
                  title#twitter Twitter
                  desc#twitterDesc Link to this job posting on Twitter
                  path(d="M20 1.9c-.7.3-1.5.5-2.4.6.9-.5 1.5-1.3 1.8-2.2-.8.5-1.7.8-2.6 1C16 .5 15 0 13.8 0c-2.3 0-4.1 1.8-4.1 4 0 .3 0 .6.1.9C6.4 4.7 3.4 3.1 1.3.7c-.4.6-.6 1.3-.6 2 0 1.4.7 2.6 1.8 3.4-.7 0-1.3-.2-1.9-.5 0 2 1.4 3.6 3.3 4-.3.1-.7.1-1.1.1-.3 0-.5 0-.8-.1.5 1.6 2 2.8 3.8 2.8-1.4 1.1-3.2 1.7-5.1 1.7-.3 0-.7 0-1-.1 1.8 1.2 4 1.8 6.3 1.8 7.5 0 11.7-6.2 11.7-11.5v-.5c1.1-.4 1.7-1.1 2.3-1.9z" fill="#735e73")

              a.li-share(:href="`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(jobUrl(job))}`" target="_blank")
                svg(width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink")
                  title#linkedin LinkedIn
                  desc#linkedinDesc Link to this job posting on LinkedIn
                  g(stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
                    g(transform="translate(-321.000000, -3388.000000)" fill="#735E73" fill-rule="nonzero")
                      g(transform="translate(321.000000, 3388.000000)")
                        path(d="M14.99625,15 L14.99625,14.999375 L15,14.999375 L15,9.498125 C15,6.806875 14.420625,4.73375 11.274375,4.73375 C9.761875,4.73375 8.746875,5.56375 8.3325,6.350625 L8.28875,6.350625 L8.28875,4.985 L5.305625,4.985 L5.305625,14.999375 L8.411875,14.999375 L8.411875,10.040625 C8.411875,8.735 8.659375,7.4725 10.27625,7.4725 C11.869375,7.4725 11.893125,8.9625 11.893125,10.124375 L11.893125,15 L14.99625,15 Z" id="Path")
                        polygon(id="Path" points="0.2475 4.985625 3.3575 4.985625 3.3575 15 0.2475 15")
                        path(d="M1.80125,1.09245946e-13 C0.806875,1.09245946e-13 4.36539693e-13,0.806875 4.36539693e-13,1.80125 C4.36539693e-13,2.795625 0.806875,3.619375 1.80125,3.619375 C2.795625,3.619375 3.6025,2.795625 3.6025,1.80125 C3.601875,0.806875 2.795,1.09245946e-13 1.80125,1.09245946e-13 Z" id="Path")

      .no-content-wrap(v-if="!paginatedJobs.length")
        template(v-if="!jobs.length") No results found
        template(v-else) No results after aplying filters

  .row.paginationContainer(v-if="paginatedJobs.length")
    button.mr-btn(@click="onPrevPageClick" :class="{disabled: processing || selectedPage === 1}" :disabled="processing || selectedPage === 1")
      i.icon-caret-left.clickable

    .pagesCountWrapper(:class="{disabled: !lastPageNumber}")
      .pagesCount {{ lastPageNumber ? `Page ${selectedPage} of ${lastPageNumber}` : (processing ? 'Fetching Job posts...' : 'No results')}}

    button.mr-btn(@click="onNextPageClick" :class="{disabled: processing || !lastPageNumber || selectedPage === lastPageNumber}" :disabled="processing || !lastPageNumber || selectedPage === lastPageNumber")
      i.icon-caret-right.clickable

</template>
<script>
import { mapActions } from 'vuex';
import { getJobsFromBoard, getJobsFromPuckBoard } from '@services/vueGreenhouseSvc';
import MrDropdown from '@components/MrDropdown';

export default {
  name: 'GreenHouseJobBoardWithSearch',

  components: { MrDropdown },

  props: {
    overTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '',
    },
    jobBoardName: {
      type: String,
      default: '',
    },
    baseUrl: {
      type: String,
      default: '',
    },
    puckBoard: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data() {
    return ({
      jobs: [],
      selectedLocation: null,
      selectedRole: null,
      processing: false,
      selectedPage: 1,
      hostString: '',
    });
  },

  computed: {
    lastPageNumber() {
      return Math.ceil(this.selectedJobs.length/10);
    },

    selectedJobs() {
      let result = this.jobs;

      if (this.selectedLocation && this.selectedLocation !== 'all') {
        result = result.filter(job => this.extractCustomHubName(job).toLowerCase() === this.selectedLocation);
      }

      if (this.selectedRole && this.selectedRole !== 'all') {
        result = result.filter(job => this.extractCustomRoleType(job).toLowerCase() === this.selectedRole);
      }

      return result;
    },

    paginatedJobs() {
      return this.selectedJobs.slice((this.selectedPage - 1) * 10, this.selectedPage * 10);
    },

    locationOptions() {
      let originalArray = [{ value: 'all', label: 'Show All' }];
      let locationsMap = {};

      this.jobs.forEach(job => {
        let value = this.extractCustomHubName(job);

        if (value) {
          locationsMap[value.toLowerCase()] = { value: value.toLowerCase(), label: value };
        }
      });

      let existingLocations = Object.keys(locationsMap).map(key => locationsMap[key]);
      existingLocations.sort((first, second) => first.value.localeCompare(second.value));

      return [...originalArray, ...existingLocations];
    },

    roleOptions() {
      let originalArray = [{ value: 'all', label: 'Show All' }];
      let rolesMap = {};

      this.jobs.forEach(job => {
        let value = this.extractCustomRoleType(job);

        if (value) {
          rolesMap[value.toLowerCase()] = { value: value.toLowerCase(), label: value };
        }
      });

      let existingLocations = Object.keys(rolesMap).map(key => rolesMap[key]);
      return [...originalArray, ...existingLocations];
    },
  },

  watch: {
    selectedJobs() {
      this.selectedPage = 1;
    },
  },

  mounted() {
    this.getJobs().then(() => {
      this.selectedLocation = this.locationOptions[0].value;
      this.selectedRole = this.roleOptions[0].value;
    });

    this.hostString = `${window.location.protocol}//${window.location.host}`;
  },

  methods: {
    ...mapActions(['notifyError']),

    onPrevPageClick() {
      this.selectedPage = this.selectedPage - 1;
      this.scrollTo('.filterJobs', 150);
    },

    onNextPageClick() {
      this.selectedPage = this.selectedPage + 1;
      this.scrollTo('.filterJobs', 150);
    },

    getJobs() {
      this.processing = true;
      const getJobs = this.puckBoard ? getJobsFromPuckBoard : getJobsFromBoard;

      return getJobs({boardName: this.jobBoardName}).then(res => {
        this.processJobs(res.data.jobs);
        this.processing = false;
      }).catch(error => {this.notifyError(error); this.processing = false;});
    },

    jobUrl(job) {
      return this.puckBoard ? job.absolute_url : this.ghJobUrl(job);
    },

    ghJobUrl(job) {
      let title = job.title.toLowerCase().replace(/[^a-zA-Z0-9 ]/g, "").replace(/^\s+|\s+$/g, "").replace(/\s+/g, "-");
      return `${this.hostString}${this.baseUrl}${this.jobBoardName}/${title}/${job.id}?gh_src=mrHcbJobBoard`;
    },

    jobType(job) {
      let value = job.metadata[0].value;
      return typeof value === 'string' ? value.toLowerCase() : null;
    },

    processJobs(jobs) {
      jobs.forEach(job => {
        if (job.location && job.location.name) {
          let cityState = job.location.name.split(',');

          if (cityState[0]) {
            job.city = cityState[0];
          }

          if (cityState[1]) {
            job.state = cityState[1].replace(' ', '').trim();
          } else {
            job.state = 'ALL LOCATIONS';
          }
        }

        job.mixin = job.title.toLowerCase();
        job.mixin = job.mixin.replace(/[^a-zA-Z0-9 ]/g, ''); // remove special characters
        job.mixin = job.mixin.replace(/^\s+|\s+$/g, ''); // remove leading/trailing spaces
        job.mixin = job.mixin.replace(/\s+/g, '-'); // replace spaces with dashes
      });

      this.jobs = jobs.sort((first, second) => {
        if (first.state < second.state || first.city < second.city || first.title < second.title) {
          return -1;
        } else if (first.state > second.state || first.city > second.city || first.title > second.title) {
          return 1;
        } else {
          return 0;
        }
      });
    },

    extractCustomHubName(job) {
      return this.getMetadataField(job, "haircolorbar_hub");
    },

    extractCustomRoleType(job) {
      return this.getMetadataField(job, "haircolorbar_role_type");
    },

    getMetadataField(job, fieldname) {
      let value_container = job.metadata.find(element => element.name === fieldname);

      return (value_container.value_type === "multi_select" ? (value_container.value || [])[0] : value_container.value) || '';
    }
  },
};
</script>
<style lang="stylus" scoped>
.greenhouse-job-board-with-search
  overflow hidden

  .paginationContainer
    background-color #eae8e9
    padding 6px
    display flex
    margin-bottom 2rem
    align-items center
    padding-left 1%
    padding-right 1%

    @media mq-desktop-md-less
      margin-left 2%
      margin-right 2%

    @media mq-tablet-less
      margin-left 3%
      margin-right 3%

    @media mq-desktop-plus
      margin-bottom 8.0625rem

    .pagesCountWrapper
      flex-grow 1
      text-align center

  .search
    padding-top 2rem

    @media mq-desktop-plus
      padding-top 6rem

    p.searchJobs
      font-family f-primary
      font-size 1.25rem
      line-height 30px
      color color-mister-darker-gray

      letter-spacing 0.9px
      text-align center
      opacity 60
      margin-bottom 1.25rem

    .main-title
      color brand-color-1

    p.searchJobs,
    h2
      text-align center
      text-transform uppercase

    h2
      font-family "Kapra-Regular", sans-serif
      font-size 40px
      line-height 56px
      color color-mister-darker-gray

      margin 1rem .5rem

      @media mq-desktop-plus
        font-family "Kapra-Regular", sans-serif
        font-size 3.625rem
        line-height 56px
        color color-mister-darker-gray

        margin-bottom 4.375rem

    .filterJobs
      position relative

      .search-input
        margin-left 1%
        margin-right 1%
        padding-top 0.4%

        @media mq-desktop-md-less
          margin-bottom 10px
          margin-left 0%
          margin-right 0%
          padding-left 1%
          padding-right 1%

      .search-button
        margin-left 1%

        @media mq-desktop-md-less
          margin-top 10px
          width 98%

      @media mq-desktop-md-less
        flex-direction column
        align-items center
        select,
        button
          width 95%

        select
          margin-bottom 0.625rem

    .jobsContainer
      padding-top 0.375rem
      display flex
      flex-direction column
      align-items center


      @media mq-tablet-plus
        padding-top 5.375rem

      .jobRow
        width 100%

        &.with-content
          padding-top 5rem

      .no-content-wrap
        width 100%
        text-align center
        padding 30px

      .job
        margin-bottom 1.65625rem
        padding-bottom 1.84375rem
        margin-left 5%
        display flex
        width 90%
        justify-content space-between
        border-bottom 1px solid lightgray

        @media mq-desktop-md-less
          flex-direction column

        .position
          font-family f-primary-bold
          font-size 1.1875rem
          color #41273b
          text-transform none

          font-weight bold
          letter-spacing 0
          width 400px

          @media mq-desktop-md-less
            margin-bottom 0.5rem
            width 100%

        .city-posType
          display flex
          justify-content space-between
          width 350px
          opacity 0.6

          font-family f-primary
          font-size 1.1875rem
          color color-mister-darker-gray
          text-transform none

          text-transform capitalize
          letter-spacing 0

          span
            margin 0 0.625rem
            display none


          @media (max-width 1080px)
            width auto
            justify-content flex-start
            & span
              display inline

          @media mq-desktop-md-less
            margin-bottom 0.625rem


        .social
          display flex
          justify-content space-between
          min-width 80px

          .fb-share path hover
           fill #1877F2

         .tw-share path hover
           fill #1DA1F2

         .li-share g hover
          fill #0A66C1

        svg
          height 20px

        @media mq-desktop-md-less
          svg
            height 15px

      .viewMoreSocial
        width 20%
        display flex
        justify-content space-between

        @media mq-desktop-md-less
          width 100%

      .viewMore
        font-family f-primary-bold
        font-size 1rem
        color #911885

        letter-spacing 0.23px
</style>